<template>
    <div>
        <!-- new code -->
        <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar class="toolbar">
                    <v-btn icon dark @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Response Analysis</v-toolbar-title>
                </v-toolbar>
                <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                    <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                    <v-btn dark text @click="snackbar = false">Close</v-btn>
                </v-snackbar>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-card class="box">
                    <v-row justify="center" dense v-if="chapters_list != ''">
                        <v-col cols="12" sm="2" md="2">
                            <p><v-icon color="error">*</v-icon><b>Chapter List</b></p>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="chapter"
                                :items="chapters_list" item-text="name" item-value="id" label="Chapter" outlined
                                persistent-hint hint="Please Select Chapter" multiple />
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense v-if="chapters_list != ''">
                        <v-btn @click="type = 'today'; question_list = ''" class="mr-2" small
                            color="warning">Today</v-btn>
                        <v-btn @click="type = 'cummulative'; question_list = ''" class="mr-2" small
                            color="success">Cumulative</v-btn>
                        <v-btn @click="type = 'date_range'; question_list = ''" class="mr-2" small
                            color="secondary">Date
                            Range</v-btn>
                    </v-row>
                    <v-row justify="center" dense v-if="type == 'date_range' && chapters_list != ''">
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field v-model="start_date" v-bind="attrs"
                                        @blur="sdate = parseDate(start_date)" persistent-hint v-on="on"
                                        name="Start_Date" label="Start Date" prepend-icon="event"></v-text-field>
                                </v-col>
                            </template>
                            <v-date-picker v-model="sdate" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>

                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field v-bind="attrs" v-model="end_date" @blur="edate = parseDate(end_date)"
                                        persistent-hint v-on="on" name="End_Date" label="End Date"
                                        prepend-icon="event"></v-text-field>
                                </v-col>
                            </template>
                            <v-date-picker v-model="edate" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-row>
                    <v-row justify="center" v-if="type != null">
                        <v-btn v-if="type == 'date_range'" class="button"
                            :disabled="start_date == null || end_date == null" @click="fetchQuestionsSubmissions()"
                            :loading="loader">Fetch</v-btn>
                        <v-btn v-else class="button" @click="fetchQuestionsSubmissions()"
                            :loading="loader">Fetch</v-btn>
                    </v-row>

                    <!-- {{question_response_list}} -->

                    <v-toolbar dense v-if="question_list != ''" flat class="toolbar">
                        <v-toolbar-title>Question List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>

                    </v-toolbar>
                    <br />
                    <v-data-table v-if="question_list != ''" :headers="headers" show-select :items="bookList1"
                        v-model="selected" item-key="id" :search="search" class="elevation-1 mytable"
                        :items-per-page="-1" fixed-header height="400px">
                        <template v-slot:[`item.filepath`]="{ item }">
                            <v-btn icon @click="viewQuizQuestion(item)"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                        </template>
                        <template v-slot:[`item.response`]="{ item }">
                            <v-btn small class="button" @click="getStudentResponseData(item)"> View Response</v-btn>
                        </template>
                        <template v-slot:[`item.question`]="{ item }">
                            <span v-if="item.question" v-html="item.question"> </span>
                        </template>
                        <template v-slot:[`item.is_answer_submission_stopped`]="{ item }">
                            <v-switch v-model="item.is_answer_submission_stopped"
                                @change="markSubmissionWindow(item)"></v-switch>
                        </template>
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="12" md="3">
                                    <span v-for="header in headers" :key="header.text">
                                        <span v-if="filters.hasOwnProperty(header.value)">
                                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense
                                                outlined color="#0F2027" :label="header.text" multiple clearable
                                                :items="columnValueList(header.value)"
                                                v-model="filters[header.value]"></v-autocomplete>
                                        </span>
                                    </span>
                                </v-col>


                                <v-col cols="12" md="3">
                                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" sm="1" md="1"></v-col> -->
                                <v-col cols="12" md="3">
                                    <v-btn class="button" :loading="stopAllSubmissionWindow1"
                                        @click="stopAllSubmissionWindow()">Stop All
                                        Submissions</v-btn>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-btn class="button" @click="stopSelectedSubmissionWindow()"
                                        :loading="stopSelectedloader1">Stop
                                        Selected
                                        Submissions</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>

                    <v-row justify="center" v-if="question_list != ''" dense>
                        <chart auto-resize :options="option"></chart>
                        <center>
                            <strong> <v-icon style="color: orange;">mdi-checkbox-blank-circle</v-icon> Avg Response Time
                                In Sec </strong>
                        </center>
                        <chart auto-resize :options="option1"></chart>
                        <center>
                            <strong>
                                <v-icon style="color: #278962;">mdi-checkbox-blank-circle</v-icon> Correct# <v-icon
                                    style="color: #eb4034;">mdi-checkbox-blank-circle</v-icon> Wrong#
                                <v-icon style="color: #1f139e;">mdi-checkbox-blank-circle</v-icon> Not Attempt#
                            </strong>
                        </center>
                        <chart auto-resize :options="option2"></chart>
                    </v-row>
                </v-card>
                <v-dialog v-model="show_response_card" fullscreen hide-overlay persistent>
                    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                        <v-btn dark text @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="show_response_card = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Results</v-toolbar-title>
                    </v-toolbar>
                    <v-card>
                        <span v-if="question_response_list != ''" class="text1">
                            <center><strong v-html="question_response_list[0].question"></strong></center>
                        </span>
                        <v-card class="box">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Response Analysis </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <br />
                            <v-data-table fixed-header height="400px" :headers="headers2"
                                :items="question_response_list" class="elevation-1 mytable" dense :items-per-page="-1">
                                <template v-slot:[`item.correct_answer`]="{ item }">
                                    <span v-html="item.correct_answer"> </span>
                                </template>
                                <template v-slot:[`item.selected_answer`]="{ item }">
                                    <span v-html="item.selected_answer"> </span>
                                </template>
                                <template v-slot:[`item.view`]="{ item }">
                                    <span v-if="item.submission_date != '--'">
                                        <v-btn icon @click="viewSubmission(item)"> <v-icon
                                                color="black">mdi-eye</v-icon></v-btn>
                                    </span>
                                    <span v-else>--</span>
                                </template>
                                <template v-slot:[`item.is_correct`]="{ item }">
                                    <span v-if="item.is_correct">
                                        <v-icon class="mr-2 v-icon-size"
                                            color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:[`item.remark`]="{ item }">
                                    <v-btn icon> <v-icon class="btn-css btn" color="primary"
                                            @click="editItem(item)">mdi-eye</v-icon></v-btn>
                                </template>
                            </v-data-table>

                            <chart auto-resize :options="option3"></chart>

                            <v-row justify="center" dense v-if="question_response_list != ''">
                                <v-btn @click="graph_type = 'total_correct'" v-if="bar_graph_details_single_que != ''"
                                    class="mr-2" small color="success">Avg Time Of Correct Ans Given By Students</v-btn>
                                <v-btn @click="graph_type = 'total_wrong'" v-if="bar_graph_details_single_que != ''"
                                    class="mr-2" small color="warning">Avg Time Of Wrong Ans Given By Students</v-btn>
                                <v-btn @click="graph_type = 'total_not_attempt'"
                                    v-if="bar_graph_details_single_que != ''" class="mr-2" small
                                    color="secondary">Questions Not attempted Students</v-btn>
                            </v-row>

                            <chart v-if="graph_type == 'total_correct'" auto-resize :options="option4"></chart>
                            <chart v-if="graph_type == 'total_wrong'" auto-resize :options="option5"></chart>
                            <v-card class="box" v-if="graph_type == 'total_not_attempt'">
                                <v-chip class="mr-2 mb-2" color="primary"
                                    v-for="option, index in bar_graph_details_single_que[5]" :key="index">
                                    {{ option }}
                                </v-chip>
                            </v-card>
                        </v-card>
                    </v-card>
                </v-dialog>

                <v-row justify="center">
                    <v-dialog v-model="dialog_view_mcq" persistent max-width="800px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> MCQ Question </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>

                            <br />
                            <!-- {{view_question_list}} -->
                            <v-card-text>
                                <v-container>
                                    <v-card class="box">
                                        <v-row justify="center">
                                            <span class="text1">
                                                <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                            </span>
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Problem Statement</strong></span>
                                                </center>
                                            </v-col>
                                        </v-row>

                                        <span v-if="view_question_list.filepath != null">
                                            <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                                v-html="view_question_list.quizQuestion_text"> </span>
                                            <!-- <img class="imgs" :src="basepath + view_question_list.filepath" @click="zooimg(basepath + view_question_list.filepath)" /> -->
                                            <v-dialog v-model="dialog_view_img" max-width="500px">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color="black"
                                                        @click="dialog_view_img = true">mdi-eye</v-icon>
                                                </template>
                                                <v-card>
                                                    <v-toolbar class="toolbar" flat dense>
                                                        <v-toolbar-title>
                                                            <h6>
                                                                <strong> Images </strong>
                                                            </h6>
                                                        </v-toolbar-title>
                                                    </v-toolbar>
                                                    <br />
                                                    <v-card-text>
                                                        <center>
                                                            <img :src="basepath + view_question_list.filepath"
                                                                style="border: 3px solid black;" alt="Image"
                                                                width="200px" height="200px" />
                                                        </center>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn color="error" class="justify-center" rounded
                                                            @click="dialog_view_img = false">Close</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </span>
                                        <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong>Options</strong></span>
                                            </center>
                                        </v-col>
                                        <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                            <v-row align="center">
                                                <v-col cols="1">
                                                    <input class="radiospace" type="radio" v-if="option.iscorrect"
                                                        :checked="option.op_id" />
                                                    <input type="radio" name="opt" class="radiospace" v-else
                                                        v-model="option.op_id" disabled />
                                                </v-col>

                                                <!-- Column for options -->
                                                <v-col cols="9">
                                                    <div style="display: flex; align-items: center;">
                                                        <span class="span-mr" v-if="option.mcq_option_file_path == null"
                                                            v-html="option.option_value"></span>
                                                        <span v-else>
                                                            <span class="span-mr" v-if="option.option_value"
                                                                v-html="option.option_value"></span>
                                                        </span>
                                                    </div>
                                                </v-col>

                                                <!-- Column for eye icon -->
                                                <v-col cols="2">
                                                    <a :href="basepath + option.mcq_option_file_path + option.mcq_filename"
                                                        target="blank" class="p-2">
                                                        <v-icon color="black">mdi-eye</v-icon>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </span>
                                    </v-card>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_mcq = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>

                <v-row justify="center">
                    <v-dialog v-model="dialog_view_mwa" persistent max-width="800px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> Fill In The Blanks Question </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>
                            <br />
                            <!-- {{view_question_list}} -->
                            <v-card-text>
                                <v-container>
                                    <v-card class="box">
                                        <v-row justify="center">
                                            <span class="text1">
                                                <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                            </span>
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Problem Statement</strong></span>
                                                </center>
                                            </v-col>
                                        </v-row>
                                        <span v-html="view_question_list.quizQuestion_text"> </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong>Answer(s)</strong></span>
                                            </center>
                                        </v-col>
                                        <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                            <v-row>
                                                <input class="radiospace" type="radio" :checked="option.op_id" />
                                                <span class="span-mr" v-html="option.correct_answer"> </span>
                                            </v-row>
                                            <!-- </v-card> -->
                                        </span>
                                    </v-card>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_mwa = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>

                <v-row justify="center" v-if="dialog_view_mtp">
                    <v-dialog v-model="dialog_view_mtp" persistent max-width="1050px">
                        <v-card>
                            <!-- {{view_question_list}}  -->
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> Match The Pair Assignment </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-row justify="center">
                                    <span class="text1">
                                        <strong> Marks::{{ view_question_list[0].quizQuestion_marks }}</strong>
                                    </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <span class="text1">
                                                <strong>
                                                    Problem Statement:
                                                    <span v-html="view_question_list[0].quizQuestion_text"> </span>
                                                </strong>
                                            </span>
                                        </center>
                                    </v-col>
                                </v-row>

                                <span>
                                    <v-col class="p-0 m-0" cols="12" sm="12" md="12">
                                        <v-row>
                                            <v-col cols="12" sm="2" md="2"> </v-col>
                                            <v-col cols="12" sm="3" md="3">
                                                <center><b> Question </b></center>
                                            </v-col>
                                            <v-col cols="12" sm="5" md="5">
                                                <center><b> Answer </b></center>
                                            </v-col>
                                            <v-col cols="12" sm="2" md="2">
                                                <center><b> Weightage </b></center>
                                            </v-col>
                                        </v-row>
                                        <v-row class="p-0 m-0" v-for="(option, index) in view_question_list"
                                            :key="index">
                                            <span class="p-3">
                                                <strong>Pair {{ index + 1 }} </strong>
                                            </span>
                                            <a class="p-2" :href="basepath + option.filepath" target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="option.filepath != null" v-bind="attrs"
                                                            v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span> View Question file!!! </span>
                                                </v-tooltip>
                                            </a>
                                            <v-col class="border1" cols="12" sm="4" md="4">
                                                <span v-html="option.question"></span>
                                            </v-col>

                                            <a class="p-2" :href="basepath + option.mtf_ans_filepath" target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="option.mtf_ans_filepath != null"
                                                            v-bind="attrs" v-on="on"> <v-icon
                                                                color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span> View Answer file!!! </span>
                                                </v-tooltip>
                                            </a>
                                            <v-col class="border1" cols="12" sm="4" md="4">
                                                <span v-html="option.option_name"></span>
                                            </v-col>
                                            <v-col class="border1" cols="12" sm="1" md="1">
                                                <center>{{ option.mtf_marks }}</center>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </span>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_mtp = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-row justify="center">
                    <v-dialog v-model="dialog_view_swa" persistent max-width="800px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> Single Word Answer Question </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>
                            <br />
                            <!-- {{view_question_list}} -->
                            <v-card-text>
                                <v-container>
                                    <v-card class="box">
                                        <v-row justify="center">
                                            <span class="text1">
                                                <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                            </span>
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Problem Statement</strong></span>
                                                </center>
                                            </v-col>
                                        </v-row>
                                        <span v-html="view_question_list.quizQuestion_text"> </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong>Answer(s)</strong></span>
                                            </center>
                                        </v-col>
                                        <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                            <v-row>
                                                <input class="radiospace" type="radio" :checked="option.op_id" />
                                                <span class="span-mr" v-html="option.correct_answer"> </span>
                                            </v-row>
                                            <!-- </v-card> -->
                                        </span>
                                    </v-card>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_swa = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>

                <v-row justify="center">
                    <v-dialog v-model="dialog_view_subj" persistent max-width="800px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> Subjective Question </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>

                            <br />
                            <!-- {{view_question_list}} -->
                            <v-card-text>
                                <v-container>
                                    <v-card class="box">
                                        <v-row justify="center">
                                            <span class="text1">
                                                <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                            </span>
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Problem Statement</strong></span>
                                                </center>
                                            </v-col>
                                        </v-row>

                                        <span v-if="view_question_list.filepath != null">
                                            <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                                v-html="view_question_list.quizQuestion_text"> </span>
                                            <!-- <img class="imgs" :src="basepath + view_question_list.filepath" @click="zooimg(basepath + view_question_list.filepath)" /> -->
                                            <v-dialog v-model="dialog_view_img" max-width="500px">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color="black"
                                                        @click="dialog_view_img = true">mdi-eye</v-icon>
                                                </template>
                                                <v-card>
                                                    <v-toolbar class="toolbar" flat dense>
                                                        <v-toolbar-title>
                                                            <h6>
                                                                <strong> Images </strong>
                                                            </h6>
                                                        </v-toolbar-title>
                                                    </v-toolbar>
                                                    <br />
                                                    <v-card-text>
                                                        <center>
                                                            <img :src="basepath + view_question_list.filepath"
                                                                style="border: 3px solid black;" alt="Image"
                                                                width="200px" height="200px" />
                                                        </center>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn color="error" class="justify-center" rounded
                                                            @click="dialog_view_img = false">Close</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </span>
                                        <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                        <v-row dense justify="center">
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Correct / Model Answer</strong></span>
                                                </center>
                                                <span v-html="view_question_list.subjective_correct_answer"> </span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_subj = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-row justify="center">
                    <v-dialog v-model="dialog_view_tof" persistent max-width="800px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <h6>
                                        <strong> True Or False Question </strong>
                                    </h6>
                                </v-toolbar-title>
                            </v-toolbar>

                            <br />
                            <!-- {{view_question_list}} -->
                            <v-card-text>
                                <v-container>
                                    <v-card class="box">
                                        <v-row justify="center">
                                            <span class="text1">
                                                <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                            </span>
                                            <v-col cols="12" sm="12" md="12">
                                                <center>
                                                    <span class="text1"> <strong> Problem Statement</strong></span>
                                                </center>
                                            </v-col>
                                        </v-row>

                                        <span v-if="view_question_list.filepath != null">
                                            <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                                v-html="view_question_list.quizQuestion_text"> </span>
                                            <!-- <img class="imgs" :src="basepath + view_question_list.filepath" @click="zooimg(basepath + view_question_list.filepath)" /> -->
                                            <v-dialog v-model="dialog_view_img" max-width="500px">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color="black"
                                                        @click="dialog_view_img = true">mdi-eye</v-icon>
                                                </template>
                                                <v-card>
                                                    <v-toolbar class="toolbar" flat dense>
                                                        <v-toolbar-title>
                                                            <h6>
                                                                <strong> Images </strong>
                                                            </h6>
                                                        </v-toolbar-title>
                                                    </v-toolbar>
                                                    <br />
                                                    <v-card-text>
                                                        <center>
                                                            <img :src="basepath + view_question_list.filepath"
                                                                style="border: 3px solid black;" alt="Image"
                                                                width="200px" height="200px" />
                                                        </center>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn color="error" class="justify-center" rounded
                                                            @click="dialog_view_img = false">Close</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </span>
                                        <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong>Options</strong></span>
                                            </center>
                                        </v-col>
                                        <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                            <v-row align="center">
                                                <v-col cols="1">
                                                    <input class="radiospace" type="radio" v-if="option.iscorrect"
                                                        :checked="option.op_id" />
                                                    <input type="radio" name="opt" class="radiospace" v-else
                                                        v-model="option.op_id" disabled />
                                                </v-col>

                                                <!-- Column for options -->
                                                <v-col cols="9">
                                                    <div style="display: flex; align-items: center;">
                                                        <span class="span-mr" v-if="option.mcq_option_file_path == null"
                                                            v-html="option.option_value"></span>
                                                        <span v-else>
                                                            <span class="span-mr" v-if="option.option_value"
                                                                v-html="option.option_value"></span>
                                                        </span>
                                                    </div>
                                                </v-col>

                                                <!-- Column for eye icon -->
                                                <v-col cols="2">
                                                    <a :href="basepath + option.mcq_option_file_path + option.mcq_filename"
                                                        target="blank" class="p-2">
                                                        <v-icon color="black">mdi-eye</v-icon>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </span>
                                    </v-card>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="dialog_view_tof = false">Close</v-btn>
                                </v-row>
                                <br />
                                <br />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-card>
        </v-dialog>

        <v-row justify="center">
            <v-dialog v-model="submisson_dialog_mcq" persistent max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> MCQ Question Response Data </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-row justify="center" dense>
                                    <v-col cols="12" sm="10" md="10">
                                        <strong>Question : </strong><span v-if="view_question_list.quizquestion"
                                            v-html="view_question_list.quizquestion"> </span>
                                        <span v-if="view_question_list.filepath">
                                            <a class="p-2" :href="basepath + view_question_list.filepath"
                                                target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="view_question_list.filepath !== null"
                                                            v-bind="attrs" v-on="on"> <v-icon
                                                                color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span>
                                                        View Question File!!!
                                                    </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                    </v-col>
                                    <v-col cols="12" sm="2" md="2">
                                        <strong>Q. Marks : {{ view_question_list.quizquestion_marks }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="color: green;">
                                        <center>
                                            <strong>Correct Answer</strong>
                                        </center>
                                        <v-row dense>
                                            <strong> ( {{ view_question_list.correct_option_name }} )</strong>
                                            <v-textarea style="color: green;" auto-grow
                                                v-model="view_question_list.correct_option" readonly outlined
                                                rows="3"></v-textarea>
                                            <span v-if="view_question_list.mcq_option_file_path != null">
                                                <a class="p-2" :href="basepath +
            view_question_list.mcq_option_file_path +
            view_question_list.mcq_filename
            " target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon
                                                                v-if="view_question_list.mcq_option_file_path !== null"
                                                                v-bind="attrs" v-on="on"> <v-icon
                                                                    color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span> View Option File!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="">
                                        <center>
                                            <strong>Answer Given By Student</strong>
                                        </center>
                                        <v-row dense>
                                            <strong>( {{ view_question_list.learner_mcq_option_name }} ) </strong>
                                            <v-textarea readonly style="color: red;" auto-grow
                                                v-model="view_question_list.learner_mcq_option" outlined
                                                rows="3"></v-textarea>
                                            <span v-if="view_question_list.mcq_option_file_path != null">
                                                <a class="p-2" :href="basepath +
            view_question_list.lcs_mcq_option_file_path +
            view_question_list.lcs_mcq_filename
            " target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon
                                                                v-if="view_question_list.lcs_mcq_option_file_path !== null"
                                                                v-bind="attrs" v-on="on"> <v-icon
                                                                    color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span> View Option File!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-row>
                                    </v-col>
                                    <span style="color: green;"
                                        v-if="view_question_list.learner_mcq_option_name == view_question_list.correct_option_name">
                                        <strong>Answer Given By Student Is Correct</strong>
                                    </span>
                                    <span v-else style="color: red;">
                                        <strong> Answer Given By Student Is Wrong </strong>
                                    </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <strong>Options : </strong>
                                    </v-col>
                                    <v-col cols="12" sm="10" md="10">
                                        <span v-for="(opt) in view_question_list.options" :key="opt.opt_id">
                                            <v-col cols="12" sm="10" md="10">
                                                <v-row dense>
                                                    <span class="pt-2">( {{ opt.option_name }} )</span> <input
                                                        class="radiospace" type="radio" v-if="opt.iscorrect"
                                                        :checked="opt.op_id" />
                                                    <input type="radio" name="opt" class="radiospace" v-else
                                                        v-model="opt.op_id" disabled /> <span class="pt-2"
                                                        v-if="opt.option_value" v-html="opt.option_value"> </span>
                                                    <!-- <v-textarea readonly auto-grow v-model="opt.option_value" outlined rows="3"></v-textarea> -->
                                                    <span v-if="opt.mcq_option_file_path != null">
                                                        <a class="p-2" :href="basepath +
            opt.mcq_option_file_path +
            opt.mcq_filename
            " target="_blank">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon v-if="opt.mcq_option_file_path !== null"
                                                                        v-bind="attrs" v-on="on"> <v-icon
                                                                            color="black">mdi-eye</v-icon></v-btn>
                                                                </template>
                                                                <span> View Option File!!! </span>
                                                            </v-tooltip>
                                                        </a>
                                                    </span>
                                                </v-row>
                                            </v-col>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-row dense justify="center">
                                <v-btn color="error" class="justify-center" rounded
                                    @click="submisson_dialog_mcq = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="submisson_dialog_subjective" persistent max-width="900px">
                <v-card>
                    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                        <v-btn dark text @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong>Evaluation Of Subjective Question</strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card class="box">
                            <!-- {{view_question_list}} -->
                            <!-- { "submission_date": "10/Apr/2023 03:44 PM", "quizquestion": "<p>2 + 5 = ?</p>\r\n", 
                    "post_date": "10/Apr/2023 02:32 PM", "lcs_marks": 0, "lcs_id": 4, "quizquestion_marks": 1, 
                    "sub_correct_answer": null, "sub_answer": "7", "view_date": "10/Apr/2023 03:44 PM" } -->
                            <v-col cols="12" sm="12" md="12">
                                <v-row justify="center" dense>
                                    <v-col cols="12" sm="10" md="10">
                                        <strong>Question : </strong><span v-if="view_question_list.quizquestion"
                                            v-html="view_question_list.quizquestion"> </span>
                                        <span v-if="view_question_list.filepath">
                                            <a class="p-2" :href="basepath + view_question_list.filepath"
                                                target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="view_question_list.filepath !== null"
                                                            v-bind="attrs" v-on="on"> <v-icon
                                                                color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span>
                                                        View Question File!!!
                                                    </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                    </v-col>
                                    <v-col cols="12" sm="2" md="2">
                                        <strong>Q. Marks : {{ view_question_list.quizquestion_marks }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="color: green;">
                                        <center><strong>Correct Answer</strong></center>
                                        <v-textarea color="#0f2027" v-model="view_question_list.sub_correct_answer"
                                            readonly label="Correct Answer" outlined dense></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="color: red;">
                                        <center><strong>Answer Given By Student</strong></center>
                                        <v-textarea color="#0f2027" v-model="view_question_list.sub_answer" readonly
                                            label="Answer Given By Student" outlined dense></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field outlined dense label="Give Marks" type="number"
                                            v-model="view_question_list.lcs_marks"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row justify="center" dense>
                                    <v-btn color="primary" class="justify-center" rounded
                                        v-if="view_question_list.lcs_marks <= view_question_list.quizquestion_marks"
                                        @click="saveSubjectiveMarks(view_question_list.lcs_id, view_question_list.lcs_marks)">
                                        Save
                                    </v-btn>
                                    <v-btn color="error" class="justify-center" rounded
                                        @click="submisson_dialog_subjective = false">Close</v-btn>
                                </v-row>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="submisson_dialog_tof" persistent max-width="800px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> True Or False Question Response Data </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-row justify="center" dense>
                                    <v-col cols="12" sm="10" md="10">
                                        <strong>Question : </strong><span v-if="view_question_list.quizquestion"
                                            v-html="view_question_list.quizquestion"> </span>
                                        <span v-if="view_question_list.filepath">
                                            <a class="p-2" :href="basepath + view_question_list.filepath"
                                                target="blank">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-if="view_question_list.filepath !== null"
                                                            v-bind="attrs" v-on="on"> <v-icon
                                                                color="black">mdi-eye</v-icon></v-btn>
                                                    </template>
                                                    <span>
                                                        View Question File!!!
                                                    </span>
                                                </v-tooltip>
                                            </a>
                                        </span>
                                    </v-col>
                                    <v-col cols="12" sm="2" md="2">
                                        <strong>Q. Marks : {{ view_question_list.quizquestion_marks }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="color: green;">
                                        <center>
                                            <strong>Correct Answer</strong>
                                        </center>
                                        <v-row dense>
                                            <strong>{{ view_question_list.correct_option_name }}.</strong> <v-textarea
                                                style="color: green;" auto-grow
                                                v-model="view_question_list.correct_option" outlined
                                                rows="3"></v-textarea>
                                            <span v-if="view_question_list.mcq_option_file_path != null">
                                                <a class="p-2" :href="basepath +
            view_question_list.mcq_option_file_path +
            view_question_list.mcq_filename
            " target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon
                                                                v-if="view_question_list.mcq_option_file_path !== null"
                                                                v-bind="attrs" v-on="on"> <v-icon
                                                                    color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span> View Option File!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" style="">
                                        <center>
                                            <strong>Answer Given By Student</strong>
                                        </center>
                                        <v-row dense>
                                            <strong> {{ view_question_list.learner_mcq_option_name }}
                                                .</strong><v-textarea style="color: red;" auto-grow
                                                v-model="view_question_list.learner_mcq_option" outlined
                                                rows="3"></v-textarea>
                                            <span v-if="view_question_list.mcq_option_file_path != null">
                                                <a class="p-2" :href="basepath +
            view_question_list.lcs_mcq_option_file_path +
            view_question_list.lcs_mcq_filename
            " target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon
                                                                v-if="view_question_list.lcs_mcq_option_file_path !== null"
                                                                v-bind="attrs" v-on="on"> <v-icon
                                                                    color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span> View Option File!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-row>
                                    </v-col>
                                    <span style="color: green;"
                                        v-if="view_question_list.learner_mcq_option_name == view_question_list.correct_option_name">
                                        <strong>Answer Given By Student Is Correct</strong>
                                    </span>
                                    <span v-else style="color: red;">
                                        <strong> Answer Given By Student Is Wrong </strong>
                                    </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <strong>Options : </strong>
                                    </v-col>
                                    <v-col cols="12" sm="10" md="10">
                                        <span v-for="(opt) in view_question_list.options" :key="opt.opt_id">
                                            <v-col cols="12" sm="10" md="10">
                                                <v-row dense>
                                                    {{ opt.option_name }}.
                                                    <v-textarea auto-grow v-model="opt.option_value" outlined
                                                        rows="3"></v-textarea>
                                                    <span v-if="opt.mcq_option_file_path != null">
                                                        <a class="p-2" :href="basepath +
            opt.mcq_option_file_path +
            opt.mcq_filename
            " target="_blank">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn icon v-if="opt.mcq_option_file_path !== null"
                                                                        v-bind="attrs" v-on="on"> <v-icon
                                                                            color="black">mdi-eye</v-icon></v-btn>
                                                                </template>
                                                                <span> View Option File!!! </span>
                                                            </v-tooltip>
                                                        </a>
                                                    </span>
                                                </v-row>
                                            </v-col>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-row dense justify="center">
                                <v-btn color="error" class="justify-center" rounded
                                    @click="submisson_dialog_tof = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="submisson_dialog_fib" persistent max-width="800px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <h6>
                                <strong> {{ quiztype }} Question -</strong>
                            </h6>
                        </v-toolbar-title>
                    </v-toolbar>

                    <br />
                    <!-- {{view_question_list}} -->
                    <v-card class="box">
                        <v-col cols="12" sm="12" md="12">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="10" md="10"> <strong>Question : </strong><span
                                        v-if="view_question_list.quizquestion" v-html="view_question_list.quizquestion">
                                    </span>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <strong>Q. Marks : {{ view_question_list.quizquestion_marks }}</strong>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-row justify="center" dense>
                            <v-card class="box">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">Answer</th>
                                                <th class="text-left">Student Answer</th>
                                                <th class="text-left">Iscorrect</th>
                                                <th class="text-left">Marks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in view_question_list.submission_data" :key="item.id">
                                                <td>{{ item.answers }}</td>
                                                <td>{{ item.student_answers }}</td>
                                                <td>
                                                    <span v-if="item.iscorrect">
                                                        <v-icon class="mr-2 v-icon-size"
                                                            color="success">mdi-check-circle-outline</v-icon>
                                                    </span>
                                                    <span v-else>
                                                        <v-icon class="mr-2 v-icon-size"
                                                            color="error">mdi-close-circle-outline</v-icon>
                                                    </span>
                                                </td>
                                                <td>{{ item.marks }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-row>
                    </v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-row>
                            <v-btn color="error" class="justify-center" rounded
                                @click="submisson_dialog_fib = false">Close</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="submisson_dialog_mtp" persistent max-width="800px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <h6>
                                <strong> {{ quiztype }} Question -</strong>
                            </h6>
                        </v-toolbar-title>
                    </v-toolbar>

                    <br />
                    <!-- {{view_question_list}} -->
                    <v-card class="box">
                        <v-col cols="12" sm="12" md="12">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="10" md="10"> <strong>Question : </strong><span
                                        v-if="view_question_list.quizquestion" v-html="view_question_list.quizquestion">
                                    </span>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <strong>Q. Marks : {{ view_question_list.quizquestion_marks }}</strong>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-row justify="center" dense>
                            <v-card class="box">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">Question</th>
                                                <th class="text-left">Answer</th>
                                                <th class="text-left">Student Answer</th>
                                                <th class="text-left">Iscorrect</th>
                                                <th class="text-left">Marks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in view_question_list.submission_data" :key="item.id">
                                                <td>{{ item.question }}</td>
                                                <td>{{ item.answers }}</td>
                                                <td>{{ item.student_answers }}</td>
                                                <td>
                                                    <span v-if="item.iscorrect">
                                                        <v-icon class="mr-2 v-icon-size"
                                                            color="success">mdi-check-circle-outline</v-icon>
                                                    </span>
                                                    <span v-else>
                                                        <v-icon class="mr-2 v-icon-size"
                                                            color="error">mdi-close-circle-outline</v-icon>
                                                    </span>
                                                </td>
                                                <td>{{ item.marks }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-row>
                    </v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-row>
                            <v-btn color="error" class="justify-center" rounded
                                @click="submisson_dialog_mtp = false">Close</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog" max-width="900px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Give Remark</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined name="input-7-4" v-model="item_edit.remark"
                                    label="Enter Remark"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row dense justify="center">
                        <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                        <v-btn class="button" @click="saveRemark">Save</v-btn>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: ["sel_crs", "value"],
    data: () => ({
        item_edit: [],
        selected: [],
        stopSelectedloader1: false,
        dialog: false,

        quiztype: null,
        graph_type: null,
        submisson_dialog_mcq: false,
        stopAllSubmissionWindow1: false,
        submisson_dialog_subjective: false,
        submisson_dialog_tof: false,
        submisson_dialog_fib: false,
        submisson_dialog_swa: false,
        submisson_dialog_mtp: false,
        correct_ans_id: null,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        chapters_list: [],
        total_selected: [],
        chapter: "",
        type: null,
        start_date: null,
        end_date: null,
        sdate: new Date().toISOString().substr(0, 10),
        edate: new Date().toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        question_list: [],
        circle_graph_details: [],
        question_response_list: [],
        pie_graph_details: [],
        bar_graph_details_single_que: [],
        coff_id: [],
        divoff_id: [],
        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Question Post Date & Time", value: "post_date" },
            { text: "Question Type", value: "quiztype" },
            { text: "Question Statement", value: "question" },
            { text: "View Question", value: "filepath" },
            { text: "Course", value: "course" },
            { text: "Division", value: "division" },
            { text: "Chapter", value: "chapter" },
            { text: "Marks", value: "marks" },
            { text: "View Response", value: "response" },
            {
                text: "Is Submission Window Stopped ?",
                value: "is_answer_submission_stopped",
            },
        ],
        headers2: [
            { text: "Sr. No.", value: "srno" },
            { text: "Student", value: "learner" },
            { text: "Marks", value: "marks" },
            { text: "Time Taken", value: "duration" },
            { text: "Post Date", value: "post_date" },
            { text: "View Date", value: "view_date" },
            { text: "Submission Date", value: "submission_date" },
            { text: "Checked Date", value: "checked_date" },
            { text: "View", value: "view" },
            { text: "Remark", value: "remark" },
            // { text: "Correct Answer", value: "correct_answer" },
            // { text: "Selected Answer", value: "selected_answer" },
            // { text: "Is Correct", value: "is_correct" },
            // { text: "Student Ans", value: "selected_answer" },
        ],
        show_response_card: false,
        dialog_view_img: false,
        dialog_view_mcq: false,
        dialog_view_mwa: false,
        dialog_view_mtp: false,
        dialog_view_swa: false,
        dialog_view_subj: false,
        view_question_list: [],
        dialog_zooimg: false,
        img_url: null,
        loader: false,
        search: "",
        basepath: "",
        filterArr: [],
        filters: {
            quiztype: [],
        },
        bar_graph_details: [],
        bar_graph_details_overall: [],
        dialog_view_tof: false,
        ///////////////////////////////////////////////
        option: {
            title: {
                text: "Response Analysis",
                left: "center",
            },
            color: ["#278962", "#eb4034", "#1f139e"],
            tooltip: {
                trigger: "item",
            },
            legend: {
                orient: "vertical",
                left: "left",
            },
            series: [
                {
                    name: "Access From",
                    type: "pie",
                    radius: "50%",
                    data: [
                        // { value: 1048, name: 'Search Engine' },
                        // { value: 735, name: 'Direct' },
                        // { value: 580, name: 'Email' },
                        // { value: 484, name: 'Union Ads' },
                        // { value: 300, name: 'Video Ads' }
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        },

        option1: {
            color: ["#eb4034"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                    // dataView: {
                    //     show: true,
                    //     title: "Data View",
                    //     readonly: false,
                    // },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Student",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Time In Sec",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },

        option2: {
            color: ["#278962", "#eb4034", "#1f139e"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                    // dataView: {
                    //   show: true,
                    //   title: "Data View",
                    //   readonly: false,
                    // },
                },
            },
            calculable: true,
            legend: {
                data: [],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 15,
                    rotate: 45,
                },
                name: "Students",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                //   name: "Live Session Avg",
                //   nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },

        option3: {
            color: ["#278962", "#eb4034", "#1f139e"],
            tooltip: {
                trigger: "item",
            },
            legend: {
                orient: "vertical",
                left: "left",
            },
            series: [
                {
                    name: "Access From",
                    type: "pie",
                    radius: "50%",
                    data: [
                        // { value: 1048, name: 'Search Engine' },
                        // { value: 735, name: 'Direct' },
                        // { value: 580, name: 'Email' },
                        // { value: 484, name: 'Union Ads' },
                        // { value: 300, name: 'Video Ads' }
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        },

        option4: {
            color: ["green"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                    // dataView: {
                    //     show: true,
                    //     title: "Data View",
                    //     readonly: false,
                    // },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Student",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Time In Sec",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },

        option5: {
            color: ["#eb4034"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                    label: {
                        show: true,
                    },
                },
            },
            toolbox: {
                show: true,
                feature: {
                    mark: { show: true },
                    magicType: {
                        show: true,
                        type: ["line", "bar", "stack"],
                        title: {
                            line: "Switch to Line Chart",
                            bar: "Switch to Bar Chart",
                            stack: "Switch to Stack Chart",
                        },
                    },
                    restore: { show: true, title: "Restore" },
                    saveAsImage: {
                        show: true,
                        title: "Save As Image",
                    },
                    // dataView: {
                    //     show: true,
                    //     title: "Data View",
                    //     readonly: false,
                    // },
                },
            },
            calculable: true,
            legend: {
                data: ["Growth", "Budget 2011", "Budget 2012"],
                itemGap: 5,
            },
            grid: {
                top: "12%",
                // left: '1%',
                // right: '10%',
                containLabel: true,
            },
            xAxis: {
                type: "category",
                data: [],
                axisLabel: {
                    margin: 0,
                    rotate: 75,
                },
                axisTick: {
                    alignWithLabel: true,
                },
                name: "Student",
                nameLocation: "end",
                offset: 10,
            },
            yAxis: {
                type: "value",
                name: "Time In Sec",
                nameLocation: "end",
                offset: 10,
            },
            series: [
                {
                    data: [],
                    value: [],
                    type: "bar",
                },
            ],
        },



    }),
    watch: {
        sdate(val) {
            this.start_date = this.formatDate(this.sdate);
        },
        edate(val) {
            this.end_date = this.formatDate(this.edate);
        },
    },
    methods: {

        async stopAllSubmissionWindow() {
            if (!confirm("Are You Sure You Want To Close Submission Window...?")) return;
            this.stopAllSubmissionWindow1 = true;
            var question_ids = []
            for (var i = 0; i < this.question_list.length; i++) {
                question_ids.push(this.question_list[i].id);
            }
            const data = {
                question_ids: question_ids
            };
            try {
                const res = await axios.post("/LiveClass/stopAllSubmissionWindow", data);
                if (res.data.flag == "YES") {
                    this.stopAllSubmissionWindow1 = false;
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                    this.stopAllSubmissionWindow1 = false;
                }
                this.stopAllSubmissionWindow1 = false;
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                this.stopAllSubmissionWindow1 = false;
            } finally {
                this.save_loader = false;
                this.stopAllSubmissionWindow1 = false;
                this.fetchQuestionsSubmissions()
            }
        },
        async stopSelectedSubmissionWindow() {
            this.total_selected = [];
            if (!confirm("Are You Sure You Want To Close Submission Window...?")) return;
            this.stopSelectedloader1 = true;

            for (var i = 0; i < this.selected.length; i++) {
                this.total_selected.push(this.selected[i].id);
            }
            if (this.total_selected.length <= 0) {
                this.showSnackbar("#b71c1c", "Please select Questions!"); // show snackbar
                this.stopSelectedloader1 = false;
                return;
            }
            const data = {
                question_ids: this.total_selected
            };
            try {
                const res = await axios.post("/LiveClass/stopAllSubmissionWindow", data);
                if (res.data.flag == "YES") {
                    this.stopSelectedloader1 = false;
                    this.selected = [];
                    this.showSnackbar("green", "Save Stop Selected Submission Successfully...");
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                    this.stopSelectedloader1 = false;
                }
                this.stopSelectedloader1 = false;
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                this.stopSelectedloader1 = false;
            } finally {
                this.save_loader = false;
                this.stopSelectedloader1 = false;
                this.fetchQuestionsSubmissions()
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        saveRemark() {
            const data = {
                item_id: this.item_edit.id,
                remark: this.item_edit.remark,
            };
            axios
                .post("/LiveClass/saveRemark", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Save Successfully...");
                        this.dialog = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                })
                .finally(() => {
                    // 'use strict';
                });
        },
        editItem(item) {
            // this.item_edit.id = id
            // this.item_edit.remark = remark
            this.item_edit = item;
            this.dialog = true;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        saveSubjectiveMarks(lcs_id, marks) {
            //alert(marks)
            if (marks < 0) {
                this.showSnackbar("#b71c1c", "Entered marks should be positive.");
                return;
            }
            const data = {
                lcs_id: lcs_id,
                marks: marks,
            };
            axios
                .post("/LiveClass/saveSubjectiveMarks", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks Saved Successfully..."); // show snackbar on success
                        this.submisson_dialog_subjective = false;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => { });
        },

        viewSubmission(item) {
            const data = {
                lcs_id: item.id,
                type: item.quiztype,
            };
            axios
                .post("/LiveClass/viewQuestionDataSubjective", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if (res.data.quiztype == "SUBJECTIVE") {
                            this.submisson_dialog_subjective = true;
                            this.view_question_list = res.data.questions[0];
                        } else if (res.data.quiztype == "MultiWordAnswer") {
                            this.submisson_dialog_fib = true;
                            this.view_question_list = res.data.questions[0];
                            this.quiztype = res.data.quiztype_displayname;
                        } else if (res.data.quiztype == "MCQ") {
                            this.submisson_dialog_mcq = true;
                            this.view_question_list = res.data.questions[0];
                        } else if (res.data.quiztype == "TrueFalse") {
                            this.submisson_dialog_tof = true;
                            this.view_question_list = res.data.questions[0];
                        } else if (res.data.quiztype == "SWA") {
                            this.submisson_dialog_fib = true;
                            this.quiztype = res.data.quiztype_displayname;
                            this.view_question_list = res.data.questions[0];
                        } else if (res.data.quiztype == "MTP") {
                            this.submisson_dialog_mtp = true;
                            this.quiztype = res.data.quiztype_displayname;
                            this.view_question_list = res.data.questions[0];
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => { });
        },

        // viewSubmission(item) {
        //     //this.correct_ans_id = item.correct_answer_id;
        //     if (item.quiztype == "SUBJECTIVE") {
        //         const data = {
        //             lcs_id: item.id,
        //         };
        //         axios
        //             .post("/LiveClass/viewQuestionDataSubjective", data)
        //             .then((res) => {
        //                 if (res.data.flag == "YES") {
        //                     this.submisson_dialog_subjective = true;
        //                     this.view_question_list = res.data.questions[0];
        //                 } else {
        //                     this.showSnackbar("red", res.data.snackbar);
        //                     sessionStorage.setItem("error-trace", res.data.error_trace);
        //                 }
        //             })
        //             .catch((error) => {
        //                 this.onerror(error);
        //             })
        //             .finally(() => {});
        //     } else if (item.quiztype == "MultiWordAnswer") {
        //         const data = {
        //             lcs_id: item.id,
        //         };
        //         axios
        //             .post("/LiveClass/viewQuestionDataMWA", data)
        //             .then((res) => {
        //                 if (res.data.flag == "YES") {
        //                     this.submisson_dialog_fib = true;
        //                     this.view_question_list = res.data.questions[0];
        //                 } else {
        //                     this.showSnackbar("red", res.data.snackbar);
        //                     sessionStorage.setItem("error-trace", res.data.error_trace);
        //                 }
        //             })
        //             .catch((error) => {
        //                 this.onerror(error);
        //             })
        //             .finally(() => {});
        //     }

        //     else {
        //         const data = {
        //             qid: item.lsqid,
        //         };
        //         axios
        //             .post("/LiveClass/viewQuestion", data)
        //             .then((res) => {
        //                 if (res.data.flag == "YES") {
        //                     if (res.data.quiztype == "MCQ") {
        //                         //this.dialog_view_mcq = true;
        //                         this.submisson_dialog_mcq = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                     if (res.data.quiztype == "MultiWordAnswer") {
        //                         //this.dialog_view_mwa = true;
        //                         this.submisson_dialog_fib = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                     if (res.data.quiztype == "SWA") {
        //                         //this.dialog_view_swa = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                     if (res.data.quiztype == "MTP") {
        //                         //this.dialog_view_mtp = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                     if (res.data.quiztype == "SUBJECTIVE") {
        //                         this.submisson_dialog_subjective = true;
        //                         //this.dialog_view_subj = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                     if (res.data.quiztype == "TrueFalse") {
        //                         //this.dialog_view_tof = true;
        //                         this.view_question_list = res.data.questions[0];
        //                     }
        //                 } else {
        //                     this.showSnackbar("red", res.data.snackbar);
        //                     sessionStorage.setItem("error-trace", res.data.error_trace);
        //                 }
        //             })
        //             .catch((error) => {
        //                 this.onerror(error);
        //             })
        //             .finally(() => {});
        //     }
        // },

        // async viewSubmission(item) {
        //     this.correct_ans_id = item.correct_answer_id;
        //        const data = {
        //           qid: item.lsqid,
        //       };
        //       try {
        //           const res = await axios.post("/LiveClass/viewQuestion", data);
        //           if (res.data.flag == "YES") {
        //               if (res.data.quiztype == "MCQ") {
        //                   //this.dialog_view_mcq = true;
        //                   this.submisson_dialog_mcq = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //               if (res.data.quiztype == "MultiWordAnswer") {
        //                   //this.dialog_view_mwa = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //               if (res.data.quiztype == "SWA") {
        //                   //this.dialog_view_swa = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //               if (res.data.quiztype == "MTP") {
        //                   //this.dialog_view_mtp = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //               if (res.data.quiztype == "SUBJECTIVE") {
        //                 this.submisson_dialog_subjective = true
        //                   //this.dialog_view_subj = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //               if (res.data.quiztype == "TrueFalse") {
        //                   //this.dialog_view_tof = true;
        //                   this.view_question_list = res.data.questions[0];
        //               }
        //           }
        //           if (res.data.flag == "No") {
        //               this.showSnackbar("red", res.data.snackbar); // show snackbar
        //           }
        //       } catch (error) {
        //           this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        //       } finally {
        //       }

        // },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            console.log("in col fin", val);
            return this.question_list.map((d) => d[val]);
        },
        zooimg(url_img) {
            this.img_url = url_img;
            this.dialog_zooimg = true;
        },
        async viewQuizQuestion(item) {
            const data = {
                qid: item.id,
            };
            try {
                const res = await axios.post("/LiveClass/viewQuestion", data);
                if (res.data.flag == "YES") {
                    if (res.data.quiztype == "MCQ") {
                        this.dialog_view_mcq = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "MultiWordAnswer") {
                        this.dialog_view_mwa = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "SWA") {
                        this.dialog_view_swa = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "MTP") {
                        this.dialog_view_mtp = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "SUBJECTIVE") {
                        this.dialog_view_subj = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "TrueFalse") {
                        this.dialog_view_tof = true;
                        this.view_question_list = res.data.questions[0];
                    }
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
            }
        },
        async markSubmissionWindow(item) {
            const data = {
                qid: item.id,
                is_answer_submission_stopped: item.is_answer_submission_stopped,
            };
            try {
                const res = await axios.post("/LiveClass/markSubmissionWindow", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Updated Successfully..."); // show snackbar
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                this.fetchQuestionsSubmissions();
            }
        },
        async getStudentResponseData(item) {
            const data = {
                qid: item.id,
            };
            try {
                const res = await axios.post("/LiveClass/getStudentResponseData", data);
                if (res.data.flag == "YES") {
                    this.question_response_list = res.data.question_response_list;
                    this.pie_graph_details = res.data.pie_graph_details;
                    this.bar_graph_details_single_que = res.data.bar_graph_details
                    var graph_data = [];
                    for (var i = 0; i < this.pie_graph_details.length; i++) {
                        graph_data.push(this.pie_graph_details[i]);
                    }
                    this.option3.series[0].data = graph_data;


                    this.option4.xAxis.data = this.bar_graph_details_single_que[1];
                    this.option4.series[0].data = this.bar_graph_details_single_que[0];

                    this.option5.xAxis.data = this.bar_graph_details_single_que[3];
                    this.option5.series[0].data = this.bar_graph_details_single_que[2];

                    if (this.question_response_list.length == 0) {
                        this.showSnackbar("red", "No Submissions Found..."); // show snackbar
                        return;
                    }
                    this.show_response_card = true;
                    //this.showSnackbar("green", "Updated Successfully..."); // show snackbar
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                this.save_loader = false;
            }
        },
        async fetchQuestionsSubmissions() {
            this.loader = true;
            this.coff_id = [];
            this.divoff_id = [];
            for (var i = 0; i < this.sel_crs.length; i++) {
                this.coff_id.push(this.sel_crs[i].coff_id);
                this.divoff_id.push(this.sel_crs[i].divoff_id);
            }
            const data = {
                chapter: this.chapter,
                coff_id: this.coff_id,
                divoff_id: this.divoff_id,
                type: this.type,
                start_date: this.start_date,
                end_date: this.end_date,
            };
            try {
                const res = await axios.post("/LiveClass/fetchQuestionsSubmissions", data);
                if (res.data.flag == "YES") {
                    this.question_list = res.data.question_list;
                    this.circle_graph_details = res.data.circle_graph_details;
                    this.bar_graph_details = res.data.bar_graph_details;
                    this.option1.xAxis.data = this.bar_graph_details[0];
                    this.option1.series[0].data = this.bar_graph_details[1];
                    var graph_data = [];
                    for (var i = 0; i < this.circle_graph_details.length; i++) {
                        graph_data.push(this.circle_graph_details[i]);
                    }
                    this.option.series[0].data = graph_data;

                    this.bar_graph_details_overall = res.data.bar_graph_details_overall;
                    this.option2.xAxis.data = this.bar_graph_details_overall[0];
                    this.option2.series[0].data = this.bar_graph_details_overall[1];
                    this.option2.series[1].data = this.bar_graph_details_overall[2];
                    this.option2.series[2].data = this.bar_graph_details_overall[3];
                    this.loader = false;
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                    this.loader = false;
                }
                this.loader = false;
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                this.loader = false;
            } finally {
                this.save_loader = false;
                this.loader = false;
            }
        },
        async call() {
            const formdata = {
                sel_crs: this.sel_crs,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/liveClass/getQuestions", formdata);
                if (res.data.flag == "YES") {
                    this.chapters_list = res.data.chaptersAll;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        ///////////
    },
    mounted() {
        this.call();
        this.basepath = localStorage.getItem("awspath");
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        bookList1() {
            return this.question_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
};
</script>
<style scoped>
.echarts {
    position: relative;
    width: 100%;
    height: 90vh;
}

.tbhead {
    font-weight: 900;
    font-size: 15px;
    color: red;
}

.button {
    border: 2px solid #424093 !important;
    color: #424093;
    background: transparent !important;
    border-radius: 50px;
    margin: 0.5rem !important;
}

.button:hover {
    color: white;
    background: #424093 !important;
}

.toolbar {
    background-color: #ffb500 !important;
    color: #ffffff !important;
}

.btn-submit:hover {
    background-color: #ffb500 !important;
    color: #ffffff !important;
}

.radiospace {
    margin: 1rem !important;
}

.span-mr {
    margin: 0.7rem !important;
}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    width: auto;
}

.msg {
    color: red;
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.name {
    color: #ffb500;
    font-weight: bold;
    letter-spacing: 1px;
}

v-chip {
    width: auto;
}

.text1 {
    color: darkblue !important;
    margin-left: 40px;
}

.textq {
    color: rgb(24, 155, 68) !important;
    margin-left: 40px;
}

.textd {
    color: rgb(168, 173, 196) !important;
    margin-left: 40px;
}

.textg {
    color: #ffb500 !important;
    margin-left: 40px;
}

.box {
    background-color: #add8e630;
    margin: 8px !important;
    padding: 8px;
    border: 2px solid rgb(195, 214, 218) !important;
    border-radius: 10px;
}

.card-border1 {
    margin: 8px !important;
    padding: 8px;
    border: 2px solid white !important;
    border-radius: 10px;
}

.marks {
    text-align: center;
}

.card-border {
    border: 2px solid #424093;
    border-radius: 1px;
    padding: 5px;
    margin: 1rem !important;
    width: auto;
}

.border {
    border: 2px solid gray;
    padding: 10px;
    margin: 10px;
}

.border1 {
    border: 1px solid black;
    padding: 5px;
    margin: 10px;
}

.text-color {
    color: darkblue;
}

.text::v-model {
    color: white !important;
}
</style>
